<div class="container">
  <a href="#">
    <img src="assets/logo.png" alt="Disc Golf Grabbers Logo" width="500px" class="logo">
  </a>
  <div class="bg-light p-5 rounded-lg m-3">
    <h1 class="display-4">Make Retrieving Discs Easy</h1>
    <p class="lead">Never say "lost another disc" again. These disc golf grabbers take up almost no space in your bag and are simple to use.</p>
  </div>

  <div class="not-for-sale bg-light border p-4 rounded-lg m-3 text-center">
    <h2 class="h4 mb-3">No longer for sale</h2>
    <p class="mb-2">This was a fun project! I enjoyed designing these grabbers to help disc golfers retrieve lost discs from water hazards and rough terrain.</p>
    <p class="mb-3">The physical grabbers are no longer available to purchase, but the 3D print models (STL files) are free for anyone who wants to make their own:</p>
    <a href="https://www.printables.com/model/566271-disc-golf-grabber" target="_blank" rel="noopener noreferrer" class="btn btn-primary btn-lg">
      Get the models on Printables →
    </a>
  </div>

  <h3 class="vertical-padding">Check out the video to see how the disc grabber retrieves discs</h3>
  <div class="aspect-ratio">
    <iframe width="16" height="9" src="https://www.youtube.com/embed/mROW65SOl3g" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
  <router-outlet></router-outlet>
</div>
<p></p>
<footer>
  <div class="container">
    <div class="row align-items-center">
      <div class="col">
        <span class="me-3">Copyright {{date | date:'YYYY'}}, <a href="mailto:adam@discgolfgrabbers.com">adam&#64;discgolfgrabbers.com</a></span>
      </div>
    </div>
  </div>
</footer>
